module.exports = __webpack_public_path__ + "static/media/Decisions_Step0_Titlecard.9753524f.jpg";